import React from "react";

const GTMNoScript = () => (
  <noscript>
    <iframe
      src="https://www.googletagmanager.com/ns.html?id=GTM-KDDBKC3"
      height="0"
      width="0"
      title="Google Tag Manager"
      style={{ display: "none", visibility: "hidden" }}
    ></iframe>
  </noscript>
);

export default GTMNoScript;
